import { ShoppingCart } from "lucide-react";

import SwitchLinha from "./SwitchLinha";

const PERIODOS = [
  ["diario", "Diariamente", "todo dia"],
  ["semanal", "Semanalmente", "toda segunda-feira"],
  ["mensal", "Mensalmente", "primeira segunda do mês"],
];

/** Controle > Lista de compras: switch + periodicidade + horario de envio. */
export default function SecaoListaCompras({ valor, onChange }) {
  const v = valor || {};
  const set = (patch) => onChange({ ...v, ...patch });
  const legenda = (PERIODOS.find(([k]) => k === v.periodicidade) || PERIODOS[1])[2];
  return (
    <div className="bg-card border border-border rounded-lg p-6" data-e2e="secao-lista-compras">
      <div className="flex items-start gap-3 mb-4">
        <div className="p-2 rounded-lg bg-primary text-primary-foreground"><ShoppingCart className="w-5 h-5" /></div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold">Lista de compras</h2>
          <p className="text-sm text-muted-foreground">
            A Cleo manda no WhatsApp o que precisa comprar: todo item abaixo do máximo, com a quantidade para repor.
          </p>
        </div>
      </div>
      <div className="space-y-3">
        <SwitchLinha testId="sw-lista" titulo="Enviar lista de compras"
          descricao="Só entram itens com estoque máximo definido. Se não houver nada para comprar, não manda."
          ligado={!!v.enabled} onChange={(x) => set({ enabled: x })} />
        {v.enabled && (
          <div className="grid sm:grid-cols-[1fr_auto] gap-3 items-end p-3.5 rounded-lg border">
            <div>
              <p className="text-xs font-medium mb-1.5">Com que frequência?</p>
              <div className="grid grid-cols-3 gap-2">
                {PERIODOS.map(([k, rot]) => (
                  <button key={k} type="button" onClick={() => set({ periodicidade: k })} data-e2e={`per-${k}`} aria-pressed={v.periodicidade === k}
                    className={`h-10 rounded-lg border text-sm font-medium transition-colors ${v.periodicidade === k ? "bg-primary text-primary-foreground border-primary" : "hover:border-primary/60"}`}>
                    {rot}
                  </button>
                ))}
              </div>
              <p className="text-[11px] text-muted-foreground mt-1.5">Envio {legenda}, no horário ao lado.</p>
            </div>
            <div>
              <p className="text-xs font-medium mb-1.5">Horário</p>
              <input type="time" value={v.hora || "08:00"} onChange={(e) => set({ hora: e.target.value })} data-e2e="hora-lista"
                className="h-10 w-28 rounded-lg border bg-background px-2 text-sm tabular-nums" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
